import type { Guide } from '../types';

/**
 * S-26.10-03 — kontakty przewoźnika z TMS i typ klienta z TMS (odpowiedzi Marathonu z 16.10.2026, pyt. 38 i 56).
 * Do 26.10.2026 działały bez przełącznika — przy wydaniu schowane za przełącznikiem, bo na produkcji ich nie ma.
 */
export const guide: Guide = {
  flagKey: 'tmsContactsAndCustomerTypes',
  title: 'Kontakty przewoźnika z TMS i typ klienta z TMS',
  whatItDoes:
    'Karta przewoźnika ma sekcję „Kontakty z TMS” — osoby, e-maile i telefony z kartoteki kontrahentów w TMS (tylko do odczytu, rodzaj kontaktu po polsku), a w zapytaniu do przewoźnika taki kontakt można wybrać na adresata. Karta kontrahenta pokazuje typ klienta z TMS, a publikacja na giełdzie i zapytanie do przewoźnika — podpowiedź z tego typu, np. „bezpośredni — zwykle przez Trade”. To tylko podpowiedź: o dopuszczalności podwykonawcy dalej decyduje reguła wpisana przez człowieka.',
  audience: ['Trade', 'CS'],
  presentationItems: ['S-26.10-03'],
  steps: [
    {
      route: '/carriers/:carrierId/show',
      record: { description: 'dowolny przewoźnik z kartoteki', listPath: '/carriers' },
      target: 'carrier-tms-contacts',
      title: 'Kontakty z TMS na karcie przewoźnika',
      description:
        'Pod kontaktami wpisanymi przez Trade stoi sekcja „Kontakty z TMS” z oznaczeniem „z TMS”. Zmienia się je w TMS; w zapytaniu do przewoźnika można wybrać taki kontakt na adresata.',
      action: 'Otwórz przewoźnika z listy „Przewoźnicy” i znajdź sekcję „Kontakty z TMS”.',
      recorder: { account: 'trade', demo: { kind: 'carrier', name: 'DEMO Przewoźnik A (dane testowe)' } },
    },
    {
      route: '/contractors/:contractorId/show',
      record: { description: 'dowolny kontrahent z kartoteki', listPath: '/contractors' },
      target: 'contractor-customer-types',
      title: 'Typ klienta z TMS',
      description:
        'Na karcie kontrahenta wiersz „Typ klienta (TMS)” pokazuje typ dosłownie z TMS i zdanie, czego zwykle się spodziewać. Ta sama podpowiedź stoi przy publikacji na giełdzie i przy zapytaniu do przewoźnika.',
      action: 'Otwórz kartę kontrahenta i znajdź wiersz „Typ klienta (TMS)”.',
      recorder: { account: 'trade', demo: { kind: 'contractorOfOrder', number: 'DEMO/2026/10/RK1' } },
    },
  ],
};
